import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Description from './Description';
import Image from './Image';
import Name from './Name';
import Price from './Price';
import './App.css';

const firstName = 'James';

function App() {
  return (
    <main className="app-shell">
      <Container className="py-5 d-flex justify-content-center">
        <section className="product-card-wrap">
          {/* Product card composed from the four required components. */}
          <Card className="product-card shadow-lg border-0">
            <div className="image-frame">
              <Image />
            </div>
            <Card.Body>
              <Name />
              <Price />
              <Description />
            </Card.Body>
          </Card>

          <div className="greeting-wrap">
            <p className="greeting-text">Hello, {firstName ? firstName : 'there!'}</p>
            {/* Show profile image only when a first name is provided. */}
            {firstName ? (
              <img
                className="profile-image"
                src="/myImage2.png"
                alt="Profile"
              />
            ) : null}
          </div>
        </section>
      </Container>
    </main>
  );
}

export default App;
